export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives17.6fa172ce.jpg";